module.exports = __webpack_public_path__ + "static/demo-screen-2-238d27dca5a167382dd066b3d7245c5b.jpg";